import { createMutationHelper } from '@utils/swr'
import { type SetPasswordRequest } from '../../../types/apiRequest'
import { type CosignApis } from '../../../types/apis'

const {
  useMutation,
} = createMutationHelper<CosignApis['post']['setPassword'], never, SetPasswordRequest>({
  client: 'cosign',
  key: '/api/platform-sdk/password',
  fetcher: (url, { arg, client }) => {
    return client.post(url, arg)
  },
})

export const useRequestSetPassword = useMutation
